/**
 * Rechnungen fuer das Dashboard -- reine Funktionen, ohne Uhr.
 *
 * „Heute" kommt als Datum herein. So rechnet ein Test mit festem Tag, und der
 * Server entscheidet an einer Stelle, welche Zeitzone gilt.
 */
/** Ein ISO-Datum um Tage verschieben. Rechnet in UTC, damit keine Sommerzeit stoert. */
export function tageSpaeter(datum, tage) {
    const [j, m, t] = datum.split("-").map(Number);
    return new Date(Date.UTC(j, m - 1, t + tage)).toISOString().slice(0, 10);
}
/**
 * Die Pruefampel eines Artikels (KONZEPT.md §14.2).
 *
 * Entscheidend ist die **naechste** Pruefung: Ein Geraet mit einer
 * ueberfaelligen und einer gueltigen Pruefung ist ueberfaellig. Pruefungen ohne
 * Termin zaehlen nicht mit; hat ein Artikel nur solche, ist er „ohne Termin".
 */
export function pruefAmpel(pruefungen, heute, fristTage) {
    const mitTermin = pruefungen
        .filter((p) => p.faellig !== null)
        .sort((a, b) => (a.faellig < b.faellig ? -1 : a.faellig > b.faellig ? 1 : 0));
    const naechste = mitTermin[0];
    if (naechste === undefined)
        return { klasse: "ohne_termin", naechste: null };
    // ISO-Daten lassen sich als Zeichenketten vergleichen: gleich lang, gross vorn.
    const klasse = naechste.faellig < heute
        ? "ueberfaellig"
        : naechste.faellig <= tageSpaeter(heute, fristTage)
            ? "bald_faellig"
            : "in_ordnung";
    return { klasse, naechste };
}
/**
 * Eine lueckenlose Reihe von Tagen, aeltester zuerst.
 *
 * Die Datenbank liefert nur Tage mit Buchungen. Ein Tag ohne ist aber eine
 * Aussage -- er muss als Null im Diagramm stehen, nicht fehlen, sonst
 * rueckt der Verlauf zusammen und luegt.
 */
export function tageAuffuellen(zeilen, bis, tage) {
    const nachTag = new Map(zeilen.map((z) => [z.datum, z]));
    const reihe = [];
    for (let i = tage - 1; i >= 0; i -= 1) {
        const datum = tageSpaeter(bis, -i);
        reihe.push(nachTag.get(datum) ?? { datum, bewegungen: 0, statusaenderungen: 0 });
    }
    return reihe;
}
//# sourceMappingURL=kennzahlen.js.map